import { Loader } from "./Loader";
import { Animation } from "./Animation";

export class AnimationClip {

    public id: string;
    public start: number;
    public end: number;
    public animations: Animation[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        var idResult = loader.util.readString(dataView, offset);
        this.id = idResult.string;
        offset = idResult.offset;

        this.start = dataView.getFloat32(offset, true);
        offset += 4;

        this.end = dataView.getFloat32(offset, true);
        offset += 4;

        let animListResult = loader.util.readIdentityList<Animation>(dataView, offset);
        this.animations = animListResult.items;
        offset = animListResult.offset;
    }
}
